import { Avatar, Box, Chip, TableCell, TableRow, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import TableActions from "src/common/TableActions";
import { imgUrl } from "src/Helpers/utils/constants";
import { useApiMutation } from "src/hooks/useApiMutation";
import type { IRaffleParticipant } from "src/Types/module/raffleDraw/raffleDraw";

interface Props {
	item: IRaffleParticipant;
	serial: number;
}

const ParticipantTableRow: React.FC<Props> = ({ item, serial }) => {
	const { mutate: deleteParticipant, isPending: isDeletePending } =
		useApiMutation<void, void>({
			method: "DELETE",
			endPoint: `/api/raffle-draw/admin/participant/${item.id}`,
			invalidateQueries: ["raffle-participant"],
		});

	const avatarSrc = item.photo
		? `${imgUrl}/${item.photo}`
		: "/static/images/avatars/avatar2.png";

	return (
		<TableRow hover>
			<TableCell>
				<Typography variant="body2" color="text.primary" fontWeight={600}>
					{serial}
				</Typography>
			</TableCell>

			<TableCell>
				<Typography
					variant="body2"
					fontWeight={700}
					color="primary.main"
					sx={{ letterSpacing: 0.5 }}
				>
					{item.raffle_no || "-"}
				</Typography>
			</TableCell>

			<TableCell>
				<Typography variant="body2" color="text.secondary">
					{item.user_no || item.user_id || "-"}
				</Typography>
			</TableCell>

			<TableCell>
				<Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
					<Avatar
						src={avatarSrc}
						alt={item.name}
						sx={{ width: 34, height: 34 }}
					/>
					<Box>
						<Typography variant="body2" fontWeight={600}>
							{item.name || "N/A"}
						</Typography>
					</Box>
				</Box>
			</TableCell>

			<TableCell>
				<Box sx={{ display: "flex", flexDirection: "column" }}>
					<Typography variant="body2" color="text.primary">
						{item.phone || "-"}
					</Typography>
					{item.email && (
						<Typography variant="body1" color="text.secondary">
							{item.email}
						</Typography>
					)}
				</Box>
			</TableCell>

			<TableCell>
				<Chip
					size="small"
					label={(item.user_type || "visitor").toUpperCase()}
					color={
						item.user_type === "visitor"
							? "info"
							: item.user_type === "b2b"
								? "secondary"
								: "warning"
					}
					sx={{ fontWeight: 700, fontSize: "0.7rem", height: 22 }}
				/>
			</TableCell>

			<TableCell>
				<Chip
					size="small"
					label={item.is_winner === 1 ? "Winner" : "Not Winner"}
					color={item.is_winner === 1 ? "success" : "default"}
					sx={{ fontWeight: 600, fontSize: "0.75rem" }}
				/>
			</TableCell>

			<TableCell>
				<Typography variant="caption" color="text.secondary">
					{item.created_at ? moment(item.created_at).format("ll") : "-"}
				</Typography>
			</TableCell>

			<TableActions
				showDelete
				handleDeleteFun={() => deleteParticipant()}
				loading={isDeletePending}
			/>
		</TableRow>
	);
};

export default ParticipantTableRow;
